module.exports = __webpack_public_path__ + "files/c8005477087dcfe050bce387ca448309.png";